import script from "./edit-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-profile.vue?vue&type=script&setup=true&lang=js"

import "./edit-profile.vue?vue&type=style&index=0&id=7634cddf&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7634cddf"]])

export default __exports__